import React from 'react';
// { useState, useEffect }
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
// import { urlFor, client } from '../../client';
import './Skills.scss';

const skills = [
  {
    name: 'HTML5',
    icon: images.html,
    bgColor: '#FFF4F2',
  },
  {
    name: 'CSS3',
    icon: images.css,
    bgColor: '#dde8ee',
  },
  {
    name: 'Javascript',
    icon: images.javascript,
    bgColor: '#fdf7d1',
  },
  {
    name: 'React JS',
    icon: images.react,
    bgColor: '#ecfcff',
  },
  {
    name: 'Redux',
    icon: images.redux,
    bgColor: '#efe8fa',
  },
  {
    name: 'Angular',
    icon: images.angular,
    bgColor: '#fce8e3',
  },
  {
    name: 'Node JS',
    icon: images.node,
    bgColor: '#e7fdf3',
  },
  {
    name: 'Sass',
    icon: images.sass,
    bgColor: '#f3dde4',
  },
  {
    name: 'Git',
    icon: images.git,
    bgColor: '#fce8e3',
  },
  {
    name: 'React Native',
    icon: images.react,
    bgColor: '#ecfcff',
  },
  {
    name: 'Amazon WS',
    icon: images.aws,
    bgColor: '#FFF4F2',
  },
];

const experiences = [
  {
    year: 2021,
    works: [
      {
        name: 'Senior Architect',
        company: 'Hitachi Vantara.',
        desc: 'I working on the architect design of the new app for Hitachi customer. I am responsible for the design and the development of the new app.',
      },
    ],
  },
  {
    year: 2014,
    works: [
      {
        name: 'Principal Engineer',
        company: 'Adobe Systems',
        desc: 'I worked on the design of the existing internal application. I was responsible for the design and the development of the new feature to the existing web application.',
      },
    ],
  },
  {
    year: 2008,
    works: [
      {
        name: 'Senior System Engineer',
        company: 'IBM India',
        desc: 'I was responsible for the development of the web application for IBM customers.',
      },
    ],
  },
  {
    year: 2006,
    works: [
      {
        name: 'ColdFusion Developer',
        company: 'Emax Software',
        desc: 'I was responsible for the development of the new web application for few customers using Adobe ColdFusion.',
      },
    ],
  },
];

const Skills = () => {
  // const [experiences, setExperiences] = useState([]);
  // const [skills, setSkills] = useState([]);

  // useEffect(() => {
  //   const query = '*[_type == "experiences"] | order(year desc)';
  //   const skillsQuery = '*[_type == "skills"]';

  //   client.fetch(query).then((data) => {
  //     setExperiences(data);
  //   });

  //   client.fetch(skillsQuery).then((data) => {
  //     setSkills(data);
  //   });
  // }, []);

  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, index) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name + "_" + index}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                {/* <img src={urlFor(skill.icon)} alt={skill.name} /> */}
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div
              className="app__skills-exp-item"
              key={experience.year}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {experience.works.map((work, index) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name + index}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);
